import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';
import { Modal, Text } from '@weave/design-system';

export interface SaveExceptionsConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
  isSaving?: boolean;
}

export const SaveExceptionsConfirmModal: React.FC<SaveExceptionsConfirmModalProps> = ({
  isOpen,
  onConfirm,
  onClose,
  isSaving = false,
}) => {
  const handleConfirm = () => {
    onClose();
    onConfirm();
  };

  return (
    <Modal show={isOpen} onClose={onClose} maxWidth={460}>
      <Modal.Header onClose={onClose}>Warning!</Modal.Header>
      <Modal.Body css={styles.modalBody}>
        <Text as="p" size="medium" css={styles.text}>
          Saving and closing the handoff at this stage will result in losing any
          exceptions that you have set.
        </Text>
        <Text as="p" size="medium" css={styles.text}>
          Exceptions can only be saved once the handoff has been completed.
        </Text>
      </Modal.Body>
      <Modal.Actions
        secondaryLabel="Save Anyway"
        onSecondaryClick={handleConfirm}
        primaryLabel="Go Back"
        onPrimaryClick={onClose}
        disableSecondary={isSaving}
        disablePrimary={isSaving}
      />
    </Modal>
  );
};

const styles = {
  modalBody: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(2.5)};
    margin-top: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(1)};
  `,
  text: css`
    margin: 0;
    line-height: 1.5;
  `,
};
